import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DynamicFormComponent, ProfileService } from '../../core';
import { Document } from '../document';
import { DocumentsService } from '../documents.service';
import { DocumentsQuestionsService } from '../documents-questions.service';

@Component({
  selector: 'lms-document-editor',
  templateUrl: './document-editor.component.html',
  styleUrls: ['./document-editor.component.css']
})
export class DocumentEditorComponent implements OnInit, AfterViewInit {
  @Input() document: Document;
  @Input() clientId: any;
  @Output() onSave = new EventEmitter<Document>();
  @ViewChild('selectClientForm', { static: false }) public selectClientForm: DynamicFormComponent;
  @ViewChild('linkForm', { static: false }) public dynamicForm: DynamicFormComponent;

  public questions: any[];
  public selectClientQuestion: any[];
  public uploadType = 'file';
  public uploadUrl = '/customizations/documents';
  public uploadData: {};
  public optionsDocuments: any = [
    { label: this.translateService.instant('customizations.documents.uploadFile'), value: 'file' },
    { label: this.translateService.instant('customizations.documents.copyLink'), value: 'link' }
  ];

  constructor(
    public documentsService: DocumentsService,
    public location: Location,
    public profileService: ProfileService,
    public documentsQuestions: DocumentsQuestionsService,
    public translateService: TranslateService
  ) {}

  ngOnInit() {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      const isAdminUser = ['superAdmin', 'csm', 'csAdmin', 'supportSpecialist'].find(
        (item) => item === loggedUser.role
      );
      if (!isAdminUser) {
        this.clientId = loggedUser.clientId;
        this.questions = this.documentsQuestions.getQuestions(this.document, this.clientId);
        this.uploadData = { clientId: this.clientId };
      } else {
        this.selectClientQuestion = this.documentsQuestions.getSelectClientQuestion(this.clientId);
      }
    });
  }

  public selectOption(option: any) {
    this.uploadType = option.detail.value;
  }

  goBack(): void {
    this.location.back();
  }

  submit(documentData: any) {
    if (this.document) {
      this.onUpdate(documentData);
    } else {
      this.onCreate(documentData);
    }
  }

  onCreate(documentData: Object) {
    this.documentsService
      .create(documentData)
      .then((document) => {
        this.onSave.emit(document);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updateddocument: Document = Object.assign({}, this.document, updatedData);
    this.documentsService
      .update(updateddocument)
      .then((document) => {
        this.onSave.emit(updateddocument);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }

  onUploadFinished(document) {
    this.onSave.emit(document);
  }

  ngAfterViewInit() {
    if (this.selectClientForm) {
      this.selectClientForm.form.valueChanges.subscribe((data) => {
        this.clientId = data.clientId;
        if (this.clientId) {
          this.questions = this.documentsQuestions.getQuestions(this.document, this.clientId);
          this.uploadData = { clientId: this.clientId };
        }
      });
    }
  }
}
